export default {

  methods: {

    set_LocalValues(){

      this.tblData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title    = json.title
      this.header   = json.header
      this.table    = json.table
      this.rate     = json.rate
      this.columns  = json.columns
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries

      this.gmx_tableCoordinates('x', this.columns, 5)
      this.table.width = this.columns[this.columns.length-1].ex
      this.table.height = this.header.height + this.tblData.length * this.table.lineHeight


      // this.tblData = this.tblData.filter(f=> f.DISC=='STRUCTURE' && f.YARD=='HULL')

      this.tblData.forEach(d=> {

        d.tColor = '#000'
        d.tSize = 10.5

        if(d[this.table.group[0]] == 'OVERALL') {
          d.group = 'GRAND'
          d.tColor = '#000'
          d.tSize = 10.5

        } else if(d[this.table.group[1]] == 'OVERALL' && d[this.table.group[2]] == 'OVERALL') {
          d.group = 'SUB'
          d.tColor = '#000'
          d.tSize = 10.5

        } else if(d[this.table.group[2]] == 'OVERALL') {
          d.group = 'TOTAL'
          d.tColor = '#000'
          d.tSize = 10.5
        }

        if(!d.group) {
          d.tColor = '#333'
          d.tSize = 10
        }

        
      })

      // console.log(this.tblData)
    },

  }
}